import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {semanticColor, spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingSmall, LabelMedium} from "@khanacademy/wonder-blocks-typography";

interface Props {
    title?: string;
    message?: string;
}

const EmptyState = ({title, message}: Props): React.ReactElement | null => {
    return (
        <View style={styles.emptyState}>
            <HeadingSmall style={styles.title} tag="h2">
                {title || t`No results`}
            </HeadingSmall>
            <Strut size={spacing.medium_16} />
            <LabelMedium style={styles.message}>
                {message ||
                    t`Adjust your filters or check back after students start using Khan Academy.`}
            </LabelMedium>
        </View>
    );
};

const styles = StyleSheet.create({
    emptyState: {
        backgroundColor: semanticColor.core.background.base.subtle,
        height: 176,
        justifyContent: "center",
        textAlign: "center",
    },
    title: {
        color: semanticColor.core.foreground.neutral.strong,
    },
    message: {
        color: semanticColor.core.foreground.neutral.strong,
    },
});

export default React.memo(EmptyState);
